import styled from 'styled-components';

const TableScrollContainer = styled.div`
  position: relative;
  width:100%;
  z-index: 1;
  margin: auto;
  overflow: auto;
  max-height: 500px;
`;

export default TableScrollContainer;
